window.LazyLoader = window.LazyLoader || (() => {
  const rootMargin = '200px 0px';
  const SELECTOR = 'img[data-src], img[data-srcset], picture source[data-srcset]';
  const observed = new WeakSet();
  
  function hydrate(el) {
    if (el.tagName === 'SOURCE') {
      if (el.dataset.srcset) el.srcset = el.dataset.srcset;
      el.removeAttribute('data-srcset');
      return;
    }
    if (el.dataset.srcset) el.srcset = el.dataset.srcset;
    if (el.dataset.src) el.src = el.dataset.src;
    el.removeAttribute('data-src');
    el.removeAttribute('data-srcset');
  }
  
  const hasIO = 'IntersectionObserver' in window;
  const io = hasIO
    ? new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (!e.isIntersecting) continue;
        hydrate(e.target);
        io.unobserve(e.target);
      }
    }, { rootMargin, threshold: 0 })
    : null;
  
  function refresh(root = document) {
    const nodes = root.querySelectorAll(SELECTOR);
    if (!nodes.length) return;
    
    if (!hasIO) {
      nodes.forEach(hydrate);
      return;
    }
    
    nodes.forEach((el) => {
      if (observed.has(el)) return;
      observed.add(el);
      io.observe(el);
    });
  }
  
  // первичная инициализация
  document.addEventListener('DOMContentLoaded', () => refresh(document));
  
  return { refresh };
})();
